/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react'
import FileService from '../../services/file';
import GeneralService from '../../services/general';
import Settings from "../../AppSettings";
import StorageService from '../../services/storage';
import UpdateService from '../../services/updateservice';

import { Context } from '../../AppContext';

const locationAPI = Settings.getLocationAPI();

export default function Note(props) {
    const createDOMPurify = require('dompurify');
    const DOMPurify = createDOMPurify(window);
    const [note, setNote] = useState('');
    const context = useContext(Context);

    const getDownloadLink = (DPath, image)=>{
        UpdateService.getDownloadToken(DPath)
        .then(token => {
            image.src = locationAPI + 'documentpreviewv3/'+token+'/?' + DPath;
        })
        .catch(ex => {
        })
    }
    const getBase64Image = function (DPath, image) {
        if (context.info && context.info.Index && Settings.getPlatform() !== 'web') {
            let foundDoc = context.info.Index.find((item) => { return item.DPath === DPath });
            if (foundDoc) {
                StorageService.readFileBase64(StorageService.getDataDirectory(),StorageService.getStorageFileName(foundDoc.file) ,foundDoc.Extention)
                .then((result) => {
                    image.src =result;
                }, (err) => {
                    getDownloadLink(DPath, image);
                })
            } else {
                getDownloadLink(DPath, image);
            }
        } else {
            getDownloadLink(DPath, image);
        }
    }

    useEffect(() => {
        if (props.id) {
          //  readStorage();
          FileService.getContent(props.file.DPath,StorageService.getStorageFileName(props.file),true)
          .then(content=>{ 
            setProcessAndSetNote(content); 
          })
          .catch(err=>{
              console.log(err)
          })
        }
    }, [])


    /*

    useEffect(()=>{
        if(context.decryptedFiles && context.decryptedFiles[StorageService.getStorageFileName(props.file) ]){
            setProcessAndSetNote(FileService.decodeUnicode(context.decryptedFiles[StorageService.getStorageFileName(props.file) ]));
        }
     },[context.decryptedFiles])

    const readOnline = () => {
        FileService.getContentOnline(props.id).then((result) => {
            setProcessAndSetNote(result);
        }, (err) => { console.error(err) })
    }

    const readStorage = () => {
        StorageService.readFile(StorageService.documentsDir(),StorageService.getStorageFileName(props.file) )
            .then((result) => {
                try {
                    context.decryptFile( StorageService.getStorageFileName(props.file) ,result)
                
                } catch (ex) {
                    readOnline();
                }
            }, (err) => {
                readOnline();
            })
    }
*/
    const setProcessAndSetNote = (foundNote) => {
        var imageList = [];
        if (props.file && props.file.ImageList) {
            for (var i = 0; i < props.file.ImageList.length; i++) {
                imageList[props.file.ImageList[i].filename] = 'DPATH' + props.file.ImageList[i].DPath;
            }
        }
        setNote(GeneralService.processTags(foundNote, imageList));
    }

    useEffect(() => {
        if (note.length > 0) {
            for (var i = 0; i < props.file.ImageList.length; i++) {
                var image;
                for (var img = 0; img < document.images.length; img++) {
                    if (document.images[img].className === 'DPATH' + props.file.ImageList[i].DPath) {
                        image = document.images[img];
                        image.src = 'data:image/png;base64,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';
                        getBase64Image(props.file.ImageList[i].DPath, image);
                    }
                }
            }
        }
    }, [note]);

    return (
        <div className="padding" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note) }}></div>
        

    )
}
